import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PageShell } from '../../shared/components/page-shell/page-shell';

@Component({
  standalone: true,
  imports: [CommonModule, PageShell],
  template: `
    <app-page-shell [title]="pageTitle" [description]="pageDescription">
      <div class="flex flex-col items-center justify-center py-24 text-center">
        <div class="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 mb-6 animate-pulse">
          <svg class="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <h3 class="text-2xl font-bold text-slate-800">Seção em Desenvolvimento</h3>
        <p class="text-slate-500 max-w-md mt-3 text-lg">
          Estamos trabalhando para trazer o conteúdo de <strong>{{ pageTitle }}</strong> para a versão web. 
          Em breve você poderá gerenciar tudo por aqui com uma experiência incrível.
        </p>
        <div class="mt-10 flex gap-4">
          <div class="h-2 w-24 bg-slate-100 rounded-full overflow-hidden">
            <div class="h-full bg-blue-500 w-2/3"></div>
          </div>
          <span class="text-xs font-semibold text-slate-400 uppercase tracking-wider">65% Concluído</span>
        </div>
      </div>
    </app-page-shell>
  `
})
export class PlaceholderPage implements OnInit {
  private route = inject(ActivatedRoute);
  pageTitle = '';
  pageDescription = '';

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.pageTitle = data['title'] || 'Página';
      this.pageDescription = data['description'] || 'Esta seção estará disponível em breve.';
    });
  }
}
